module.exports = __webpack_public_path__ + "static/media/comment-medical.db59b1ca.svg";